import { M3Colors, SystemColors as SystemColorsBase } from '../../base/config/colors';
import { ThemeColorPalette, ThemeSystemColorPalette } from '../../colors.model';

export const SystemColors: ThemeSystemColorPalette = SystemColorsBase;

export const Colors: ThemeColorPalette = {
  // Default
  ...SystemColors,
  ...M3Colors,

  primary: {
    DEFAULT: '#0c2e4c',
    0: '#000000',
    10: '#001d36',
    20: '#113250',
    25: '#1f3d5c',
    30: '#2b4968',
    35: '#375474',
    40: '#446081',
    50: '#5d799b',
    60: '#7693b6',
    70: '#90aed2',
    80: '#acc9ee',
    90: '#d1e4ff',
    95: '#e9f1ff',
    98: '#f8f9ff',
    99: '#fdfcff',
    100: '#ffffff',
  },
  secondary: {
    DEFAULT: '#ffc02c',
    0: '#000000',
    10: '#261900',
    20: '#402d00',
    25: '#4e3800',
    30: '#5d4200',
    35: '#6b4d00',
    40: '#7a5900',
    50: '#9a7000',
    60: '#ba8800',
    70: '#dba100',
    80: '#fbbc28',
    90: '#ffdea3',
    95: '#ffefd6',
    98: '#fff8f2',
    99: '#fffbff',
    100: '#ffffff',
  },
  tertiary: {
    DEFAULT: '#d7d7d8',
    0: '#000000',
    10: '#1a1c1d',
    20: '#2f3132',
    25: '#3a3c3d',
    30: '#454748',
    35: '#515354',
    40: '#5d5e5f',
    50: '#767778',
    60: '#909192',
    70: '#ababac',
    80: '#c6c6c7',
    90: '#e2e2e3',
    95: '#f1f0f1',
    98: '#f9f9fa',
    99: '#fcfcfd',
    100: '#ffffff',
  },
  neutral: {
    DEFAULT: '#f3f2f7',
    0: '#000000',
    10: '#1b1c1d',
    20: '#303032',
    25: '#3b3b3d',
    30: '#464748',
    35: '#525254',
    40: '#5e5e60',
    50: '#777778',
    60: '#919092',
    70: '#acabac',
    80: '#c7c6c8',
    90: '#e4e2e3',
    95: '#f2f0f2',
    98: '#fbf9fa',
    99: '#fefbfd',
    100: '#ffffff',
  },
  'neutral-variant': {
    DEFAULT: '#e9e5f1',
    0: '#000000',
    10: '#1a1c1f',
    20: '#2e3034',
    25: '#3a3b3f',
    30: '#45474a',
    35: '#515256',
    40: '#5d5e62',
    50: '#76777b',
    60: '#8f9095',
    70: '#aaabaf',
    80: '#c6c6ca',
    90: '#e2e2e6',
    95: '#f0f0f5',
    98: '#f9f9fd',
    99: '#fdfcff',
    100: '#ffffff',
  },
  error: {
    DEFAULT: '#bf1a2f',
    0: '#000000',
    10: '#b00925',
    20: '#bf1a2f',
    25: '#c82334',
    30: '#cc2237',
    35: '#d42a3b',
    40: '#de2c3e',
    50: '#ed323b',
    60: '#e84b57',
    70: '#de6e77',
    80: '#e9969d',
    90: '#fbcbd3',
    95: '#fdeaef',
    98: '#fcf2f3',
    99: '#fef9fa',
    100: '#ffffff',
  },
  accent: {
    DEFAULT: '#e8def8',
    0: '#000000',
    10: '#1e192b',
    20: '#332d41',
    25: '#3e384c',
    30: '#4a4458',
    35: '#554f64',
    40: '#625b70',
    50: '#7b748a',
    60: '#958da4',
    70: '#b0a7bf',
    80: '#cbc2db',
    90: '#e8def8',
    95: '#f6eeff',
    98: '#fdf7ff',
    99: '#fffbff',
    100: '#ffffff',
  },
  success: {
    DEFAULT: '#018e42',
    0: '#000000',
    10: '#00210a',
    20: '#003916',
    25: '#00461d',
    30: '#005323',
    35: '#00602a',
    40: '#006d31',
    50: '#008a40',
    60: '#2ea556',
    70: '#4ec16e',
    80: '#6bdd87',
    90: '#88faa0',
    95: '#c5ffca',
    98: '#eaffe8',
    99: '#f6fff2',
    100: '#ffffff',
  },
  warning: {
    DEFAULT: '#fb5012',
    0: '#000000',
    10: '#3a0a00',
    20: '#5f1600',
    25: '#721d00',
    30: '#852300',
    35: '#9a2a00',
    40: '#af3100',
    50: '#da3f00',
    60: '#ff571d',
    70: '#ff8b68',
    80: '#ffb59f',
    90: '#ffdbd1',
    95: '#ffede8',
    98: '#fff8f6',
    99: '#fffbff',
    100: '#ffffff',
  },
  info: {
    DEFAULT: '#d3f3ee',
  },
  surface: {
    DEFAULT: '#ece6f0',
  }
};
